import Env from "../base/env.js";
import Channels from "../base/channels.js";
import lozad from "lozad";
import Launcher from "../view/launcher";
import MainnavTouch from "../ui/MainnavTouch";
import UISwitcher from "../ui/UISwitcher";
import HeaderLogo from "../ui/HeaderLogo";
import Smoothie from "../fx/Smoothie";
import { prepareToFx } from "../fx/Common";

class UI {
  constructor() {
    if (typeof history.scrollRestoration != "undefined") {
      history.scrollRestoration = "manual";
    }
    this.launcher = new Launcher();
    this.uiSwitch = new UISwitcher();
    this.headerLogo = new HeaderLogo();
    Env.framework.mainnav = new MainnavTouch();
    this.detectAppHeight();
    this.resetEnv();
    // Smooth
    this.smoothie = new Smoothie();
    this.smoothie.setup();
    //
    // prepareToFx()
  }

  appHeight() {
    const doc = document.documentElement;
    doc.style.setProperty(
      "--app-availheight",
      `${window.screen.availHeight}px`
    );
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  }

  detectAppHeight() {
    this.appHeight();
    Channels.on("window::smartresize", this.appHeight);
  }

  lazy() {
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
  }

  resetEnv() {
    Channels.on("statechange::before", function () {
      //setTimeout(() => {
      //  window.scrollTo(0, 0);
      //}, 500);

      Env.$html.classList.remove("mainnav--isOpened");
      Env.$html.classList.remove("subnav--isOpened");
    });
    Channels.on("statechange::ready", (current, old, container) => {
      Env.isVisiting = true;
      // Env.$html.classList.remove('skin--isWhite')

      // Env.$mainNav.classList.remove('is--active');
      // Env.$html.classList.remove('mainnav--isOpened')
      Env.$html.classList.remove("skin-isDark");
      Env.$html.classList.remove("anchorsSummary-isOpened");
      Env.$html.classList.remove("hide-ui");
      if (Env.isVisiting === true) {
        if (typeof Env.framework.UI.smoothie != "undefined") {
          Env.framework.UI.smoothie.setup();
        }
      }
    });
    Channels.on("statechange::finalize", () => {
      // prepareToFx()
    });
  }
}

export default UI;
